export const teamTypes ={
    SET_TEAM_LIST: 'SET_TEAM_LIST',
    SET_IS_LOADING_TEAM: 'SET_IS_LOADING_TEAM',
    SET_FILTER_TEAM_LIST: 'SET_FILTER_TEAM_LIST',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE'
}